<template>
    <v-layout row wrap>

        <v-flex xs12>
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Equipment Summary
                    <v-spacer></v-spacer>
                    <v-menu>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    dark
                                    icon
                                    v-on="on"
                            >
                                <v-icon>fa-ellipsis-v</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile v-if="showPlots" @click="exportAll()">
                                <v-list-tile-title>Export all as PDF</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="!showPlots" @click="displayPlots()">
                                <v-list-tile-title>Display equipment plots</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="!showAnomaly" @click="showAnomaly=true">
                                <v-list-tile-title>Display anomalies</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="equipment"  @click="$router.push({path: '/fault',query: {rangeStart:dateRange.start,rangeEnd:dateRange.end,equipment:equipment}})">
                                <v-list-tile-title>View faults for {{equipment}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="equipment"  @click="$router.push({path: '/modelsummary',query: {rangeStart:dateRange.start,rangeEnd:dateRange.end,equipment:equipment}})">
                                <v-list-tile-title>View anomalies for {{equipment}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="equipment"  @click="$router.push({path: '/notification-breakdown',query: {rangeStart:dateRange.start,rangeEnd:dateRange.end,equipment_name:equipment}})">
                                <v-list-tile-title>View notifications for {{equipment}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-card-title>
                <div>
                <v-layout row wrap class="pl-3">
                    <v-flex xs12 md6>
                        <date-range-selector class="mr-4" v-model="dateRange" @change="handleDateChange()" ></date-range-selector>
                        <equipment-selector v-on:ect="handleDateChange()" v-model="equipment"></equipment-selector>
                        <p v-if="floor"><strong>Floor : </strong>{{floor}}</p>
                        <p v-if="notes"><strong>Notes : </strong>{{notes}}</p>
                    </v-flex>
                    <v-flex xs12 v-show="loading">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-flex>
                </v-layout>
                    <v-layout v-if="!loading" row wrap>
                        <v-flex xs12 v-if="showAnomaly">
                            <anomaly :range="dateRange" :equipment="equipment"></anomaly>
                        </v-flex>
                        <v-flex xs12>
                            <notifications :equipment-filter="equipment" :date-range="dateRange"></notifications>
                        </v-flex>
                        <v-flex xs12>
                            <maintenance-record :equipment-filter="equipment" :date-range="dateRange"></maintenance-record>
                        </v-flex>
                        <v-flex xs12 v-if="fullVariableList&&showPlots">
                            <multi-plot-chart v-for="(unitVars,unitName) in fullVariableList" :key="unitName"
                                              :on-only="false"
                                              :date-range="dateRange"
                                              disable-responsive
                                              just-plot
                                              ref="plots"
                                              :variable-x="'timestamp'"
                                              :variables-list="unitVars"
                                              :layout-overrides="{height:unitVars.length>10 ? 800 : null,shapes:layoutOverrides.shapes,yaxis:{title:unitName,fixedrange: true},showlegend: true,legend:{...layoutOverrides.legend},xaxis:{...layoutOverrides.xaxis},hovermode:layoutOverrides.hovermode,hoverlabel:layoutOverrides.hoverlabel}"
                                              :type="'scatter'"
                            ></multi-plot-chart>
                        </v-flex>
                    </v-layout>



                </div>
            </v-card>
        </v-flex>

    </v-layout>
</template>

<script>
    import MultiPlotChart from "../components/MultiPlotChart"
    import exportAllToPDF from '../components/mixins/exportAllToPDF'
    import {getPoint,getRule,runRuleTest,callAPI} from '../helper'
    import VuePlotly from "../components/VuePlotly";
    import Plotly from 'plotly.js/dist/plotly'
    import DateRangeSelector from "../components/DateRangeSelector";
    import moment from 'moment'
    import EquipmentSelector from "../components/EquipmentSelector";
    import Anomaly from "../components/Anomaly";
    import Notifications from "./Notifications";
    import MaintenanceRecord from "./MaintenanceRecord";
    export default {
        name: 'EquipmentPlots',
        components: { MultiPlotChart,VuePlotly,DateRangeSelector,EquipmentSelector,Anomaly,Notifications,MaintenanceRecord},
        mixins:[exportAllToPDF],

        data () {
            return {
                loading:true,
                rule:null,
                showPlots:false,
                showAnomaly:false,
                equipment:null,
                dateRange: {start: null, end: null},
                equipmentName: null,
                faultDesc: null,
                highlightTime:null,
                notes:null,
                floor:null,
                relevantVariables:null,
                faultName:null,
                variableList:[],
                layoutOverrides:{},
                layout1:null,
                data1:null,
                points:[],
                plots:[],
                allVars:null,
                fullVariableList:null,
            }
        },
        methods:{
            jumpToNotification(value,facet) {
                let output = {
                    path: '/notification-breakdown',
                    query:{
                        rangeStart: this.dateRange.start,
                        rangeEnd: this.dateRange.end,
                    }
                }
                output.query[facet]=value
                this.$router.push(output)
            },
            handleDateChange(){
              this.renderPlots()
            },
            displayPlots(){
                let me=this
                this.showPlots=true
                setTimeout(function(){ me.initPlotlySync() }, 4000);
            },
            relayout(ed) {
                let plots=[]
                for (let item of this.$refs.plots){
                    if (item.$refs.plotly){
                        plots.push(item.$refs.plotly.$refs.container)
                    }
                }
                if(this.$refs.feplot){
                    plots.push(this.$refs.feplot.$refs.container)
                }
                if(this.$refs.rvplot){
                    plots.push(this.$refs.rvplot.$refs.plotly.$refs.container)
                }
                for (let plot of plots){
                    let x = plot.layout.xaxis;
                    if (x.range[0] !== ed["xaxis.range[0]"] || x.range[1] !== ed["xaxis.range[1]"]){
                        Plotly.relayout(plot, ed);
                    }
                }
            },
            initPlotlySync(){
                let plots=[]
                let me=this;
                if(!this.$refs.plots||this.$refs.plots.length<=1){
                    setTimeout(function(){ me.initPlotlySync()}, 2000);
                } else {
                    for (let item of this.$refs.plots){
                        if (item.$refs.plotly){
                            plots.push(item.$refs.plotly.$refs.container)
                        }
                    }
                    if(this.$refs.feplot){
                        plots.push(this.$refs.feplot.$refs.container)
                    }
                    if(this.$refs.rvplot){
                        plots.push(this.$refs.rvplot.$refs.plotly.$refs.container)
                    }
                    me.plots=plots;
                    plots.forEach(div => {
                        div.on("plotly_relayout", ed=> {
                            if (!ed.autosize){
                                let newl={
                                    "xaxis.range[0]":div.layout.xaxis.range[0],
                                    "xaxis.range[1]":div.layout.xaxis.range[1],
                                }
                                me.relayout(newl);
                            }
                        });
                    });
                }



            },
            async renderPlots(){
                if(!this.equipment){
                    return
                }
                let me=this;
                me.loading=true
                me.data1=null

                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    if (this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name===this.equipment){
                        this.allVars=this.$store.state.pointsListStore.pointsList.sensors[i]
                        this.notes=this.$store.state.pointsListStore.pointsList.equipment_details[i].notes
                        this.floor=this.$store.state.pointsListStore.pointsList.equipment_details[i].floor
                        break
                    }
                }
                if(this.allVars){
                    let newVarList={};
                    for (let varName of this.allVars){
                        let unit = this.getUnit(varName)
                        if (!newVarList[unit]) {
                            newVarList[unit] = [];
                        }
                        newVarList[unit].push({
                            equipment_name: this.equipment,
                            facility_name: this.$store.state.pointsListStore.facility_name,
                            name: varName,
                        })
                    }
                    this.fullVariableList=newVarList
                }
                this.layoutOverrides={
                    title:"Relevant variables",
                    xaxis: {
                        title: 'Time ',
                    },
                    yaxis:{
                        fixedrange: true
                    },
                    showlegend:true,
                    legend: {
                        orientation:'h',
                        x: 0.1,
                        y: -0.5
                    },
                    hoverlabel: {
                        namelength: -1
                    },
                    hovermode:"x",
                    shapes: this.highlightTime ? [
                        {
                            type: 'line',
                            x0:this.highlightTime,
                            y0: 0,
                            x1: this.highlightTime,
                            y1: 1,
                            yref: 'paper',
                            line:{
                                color: 'red',
                                width: 4,
                            }
                        }
                    ] : [],
                }
                this.loading=false
                if(this.showPlots) {
                    setTimeout(function () {
                        me.initPlotlySync()
                    }, 4000);
                }
            },
            async exportAll(){
                let plots=[...this.$refs.plots]
                if(this.$refs.rvplot){
                    plots.unshift(this.$refs.rvplot)
                }
                if(this.$refs.feplot){
                    plots.unshift(this.$refs.feplot)
                }
                this.exportAllItems(plots);
            },
            getUnit(varName){
                for (let point of this.points){
                    if(point.sensor_name===varName&&point.equipment_name===this.equipment){
                        if(point.unit){return point.unit}
                        break
                    }
                }
                if(varName.toLowerCase().includes("tem")){
                    return "°C"
                } else if(varName.toLowerCase().includes("press")){
                    return "kPa"
                } else if(varName.toLowerCase().includes("status")){
                    return "status"
                } else if(varName.toLowerCase().includes("_hr")){
                    return "hour"
                }
                return "";
            }
        },
        async beforeMount(){
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            this.equipment = _.get(this.$route.query, 'equipment', null)
            let rangeStart = _.get(this.$route.query, 'rangeStart', null)
            let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
            if (!!rangeStart) {
                this.dateRange = {start: rangeStart, end: rangeEnd}
            } else if(maxDate){
                this.dateRange={
                    start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                    end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
                }
            }
            let df = await getPoint({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.points = df['result']
            this.renderPlots()
        },

    }
</script>
